import React from 'react'
import PropTypes from 'prop-types'

import { Wrapper } from 'Components/UI'
import { Text } from 'Components/UI/_Legacy'

import isEmpty from 'lodash/isEmpty'
import size from 'lodash/size'

import { PROJECTS_DATA } from 'Constants/Projects/projectAdditionalData'

import Plates from './plates'
import { Container } from './styles'

function Check({ data, projectId }) {
  const project = PROJECTS_DATA.find(item => item.projectId === projectId)

  if (isEmpty(project)) return null

  if (!size(project.platformsNames)) return null

  return (
    <Container>
      <Wrapper alignItems="flex-start" flexDirection="column">
        <Text as="h3" legacyTitle lineHeight={1}>
          Check It
        </Text>
        <Plates
          columns={data.length}
          data={data}
          invert={1}
          mt={[16, 16, 48]}
          platforms={project.platformsNames}
        />
      </Wrapper>
    </Container>
  )
}

Check.defaultProps = {
  data: [],
  projectId: '',
}

Check.propTypes = {
  data: PropTypes.array,
  projectId: PropTypes.string,
}

export default Check
